import {
    Component,
    Input,
    OnInit,
    Output,
    EventEmitter,
    Injector,
} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { BaseModel, StrictBaseModelPart } from '@dev-stream/utils';
import { BaseComponent } from '@idocs/shared-ui/core';

export class PaginatorConfig extends BaseModel<PaginatorConfig> {
    protected BASE_TYPE = PaginatorConfig;
    length!: number;
    pageSize!: number;
    pageSizeOptions!: number[];
    pageIndex!: number;
    showFirstLastButtons!: boolean;

    GetDefaultValue(): StrictBaseModelPart<PaginatorConfig, never> {
        return {
            pageIndex: 0,
            length: 0,
            pageSize: 50,
            pageSizeOptions: [50, 100, 500, 1000],
            showFirstLastButtons: false,
        };
    }
}

@Component({
    selector: 'shared-ui-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent extends BaseComponent implements OnInit {
    @Input() config: PaginatorConfig = new PaginatorConfig();
    @Output() changePageOption = new EventEmitter<PageEvent>();

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {}
}
